import { render, staticRenderFns } from "./LoaderSmall.vue?vue&type=template&id=268adcac&scoped=true&"
import script from "./LoaderSmall.vue?vue&type=script&lang=js&"
export * from "./LoaderSmall.vue?vue&type=script&lang=js&"
import style0 from "./LoaderSmall.vue?vue&type=style&index=0&id=268adcac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268adcac",
  null
  
)

export default component.exports